module.exports = function() {
  return new Worker(__webpack_public_path__ + "3e3655189f5bd8094d8e.worker.js");
};